var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sells-item"},[_vm._v(" "+_vm._s(_vm.date)+" / "),_c('strong',[_vm._v(_vm._s(_vm.productName))]),_vm._v(" / "),_c('CurrencyView',{attrs:{"value":_vm.quantity,"sign":"шт"}}),_vm._v(" за ціною "),_c('CurrencyView',{attrs:{"value":_vm.price}}),_vm._v(" за шт / всього "),_c('CurrencyView',{attrs:{"value":_vm.result}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }